import { parse } from 'cookie';
import React, { createContext, useContext } from 'react';
export const DEFAULT_LANGUAGE = 'en';
export const LanguageContext = createContext(DEFAULT_LANGUAGE);
export function useLanguage() {
    return useContext(LanguageContext);
}
export function CookieLanguageProvider({ children }) {
    const { lang = DEFAULT_LANGUAGE } = parse(document.cookie);
    return (React.createElement(LanguageContext.Provider, { value: lang }, children));
}
export function StaticLanguageProvider({ language, children }) {
    return (React.createElement(LanguageContext.Provider, { value: language }, children));
}
//# sourceMappingURL=use-language.js.map